import GenericInformationTable, {
    TableRow
} from "components/ui/table/GenericInformationTable";
import { ImportLeadOtherInformationNameWithValue } from "../service/dto";

interface ImportLeadOtherInformationTableProps {
    otherInformationList: ImportLeadOtherInformationNameWithValue[] | null;
}

/**
 * ImportLeadOtherInformationTable displays other information
 * associated with a import lead.
 */
function ImportLeadOtherInformationTable({
    otherInformationList
}: ImportLeadOtherInformationTableProps) {
    if (!otherInformationList) return null;

    const rows: TableRow[] = otherInformationList.map((otherInformation) => ({
        fieldName: otherInformation.name,
        value: otherInformation.value ?? "--"
    }));

    // Determine the table title using your existing helper
    const tableTitle = "Weitere Informationen";

    return <GenericInformationTable title={tableTitle} rows={rows} />;
}

export default ImportLeadOtherInformationTable;
